
<div class="app" :class="appClasses">
  <router-view />
  <loader />
  <migration-process v-if="isEditorAndDesignEditor" />
</div>
